<template>
    <b-form-group>
        <b-form-radio-group
            class="grade-system-options"
            v-model="selected"
            :name="index"
            :options="options"
            @input="updateSelected">
        </b-form-radio-group>
    </b-form-group>
</template>

<script>
    export default {
        name: 'design-2021-four-point-scale-grade-system',
        props: {
            options: {
                type: Array,
                required: false,
                default: () => {
                    return ['Onvoldoende', 'Matig', 'Voldoende', 'Goed'];
                },
            },

            value: {
                type: String,
                required: false,
            },

            index: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                selected: this.value,
            };
        },
        methods: {
            updateSelected(value) {
                this.$emit('input', value);
            },
        },
    };
</script>

<style scoped lang="scss">
    .grade-system-options ::v-deep {
        > .custom-control {
            position: relative;

            .custom-control-label {
                position: relative;

                &:before,
                &:after {
                    left: calc(50% - 8px);
                    top: 20px;
                }

                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
</style>
